import { formatDate, formatTimeSlot } from "@/helpers/dateHelper"
import { Status } from "@/types/Status"
import dayjs from "dayjs"
import { IImbpBooking } from "./imbpBooking.types"
import { IMBP_APPOINTMENT_CANCELLATION_HOURS } from "@/constants/imbp"

export class ImbpBooking implements IImbpBooking {
  displayJobNumber: string
  mopJobNumber: string
  address: string
  postcode: string
  aesPatchAvailabilityId: string
  meterReadingFrequency: string
  juniferTicketId: string
  fuelType: string
  source: string
  customerName: string
  customerEmail: string
  customerPhone: string
  cancellationDateTime: string
  slotStartDateTime: string
  slotEndDateTime: string
  mpan?: string
  mprn?: string
  electricityMeterSerialNumber?: string
  gasMeterSerialNumber?: string
  aesJobType: string
  aesStatus: string
  createdAt: string
  installedDatetime: string
  failedDatetime: string
  billingAccountId: string
  medicalEquipment: boolean
  appointmentType: string
  installationType: string
  meterType: string

  constructor(data: {
    displayJobNumber: string
    mopJobNumber: string
    address: string
    postcode: string
    aesPatchAvailabilityId: string
    meterReadingFrequency: string
    juniferTicketId: string
    fuelType: string
    source: string
    customerName: string
    customerEmail: string
    customerPhone: string
    cancellationDateTime: string
    slotStartDateTime: string
    slotEndDateTime: string
    mpan?: string
    mprn?: string
    electricityMeterSerialNumber?: string
    gasMeterSerialNumber?: string
    aesJobType: string
    aesStatus: string
    createdAt: string
    installedDatetime: string
    failedDatetime: string
    billingAccountId: string
    medicalEquipment: boolean
    appointmentType: string
    installationType: string
    meterType: string
  }) {
    this.displayJobNumber = data.displayJobNumber
    this.mopJobNumber = data.mopJobNumber
    this.address = data.address
    this.postcode = data.postcode
    this.aesPatchAvailabilityId = data.aesPatchAvailabilityId
    this.meterReadingFrequency = data.meterReadingFrequency
    this.juniferTicketId = data.juniferTicketId
    this.fuelType = data.fuelType
    this.source = data.source
    this.customerName = data.customerName
    this.customerEmail = data.customerEmail
    this.customerPhone = data.customerPhone
    this.cancellationDateTime = data.cancellationDateTime
    this.slotStartDateTime = data.slotStartDateTime
    this.slotEndDateTime = data.slotEndDateTime
    this.mpan = data.mpan
    this.mprn = data.mprn
    this.electricityMeterSerialNumber = data.electricityMeterSerialNumber
    this.gasMeterSerialNumber = data.gasMeterSerialNumber
    this.aesJobType = data.aesJobType
    this.aesStatus = data.aesStatus
    this.createdAt = data.createdAt
    this.installedDatetime = data.installedDatetime
    this.failedDatetime = data.failedDatetime
    this.billingAccountId = data.billingAccountId
    this.medicalEquipment = data.medicalEquipment
    this.appointmentType = data.appointmentType
    this.meterType = data.meterType
    this.installationType = data.installationType
  }

  get dateFormatted(): string {
    return this.slotStartDateTime
      ? formatDate(dayjs(this.slotStartDateTime))
      : "N/A"
  }

  get timeSlotFormatted(): string {
    return this.slotStartDateTime && this.slotEndDateTime
      ? formatTimeSlot(
          dayjs(this.slotStartDateTime),
          dayjs(this.slotEndDateTime),
        )
      : "N/A"
  }

  get status(): Status {
    switch (this.aesStatus) {
      case "booked":
        return new Status("caution", "Booked")
      case "installed":
        return new Status("normal", "Completed")
      case "Failed":
        return new Status("critical", "Failed")
      case "cancelled":
        return new Status("critical", "Cancelled")
      default:
        return new Status("default", this.aesStatus)
    }
  }

  get eligibleForCancellation(): boolean {
    if (!this.slotStartDateTime) return false
    const cancellationDate = dayjs(this.slotStartDateTime).subtract(
      IMBP_APPOINTMENT_CANCELLATION_HOURS,
      "hour",
    )
    const timeIsInFuture = dayjs(cancellationDate).isAfter(dayjs(), "minute")

    return timeIsInFuture
  }
}
